import { gql, useQuery } from "@apollo/client";
import {
  CustomerReferralOverview,
  QueryCustomerReferralOverviewArgs,
} from "../../../../../../schemaTypes";

export const CUSTOMER_REFERRAL_OVERVIEW_QUERY = gql`
  query CustomerReferralOverviewQuery($id: String!) {
    customerReferralOverview(id: $id) {
      totalReferrals
    }
  }
`;

export const useCustomerReferralOverview = (
  variables: QueryCustomerReferralOverviewArgs
) => {
  const { data, loading, error, refetch } = useQuery<
    { customerReferralOverview?: CustomerReferralOverview | null },
    QueryCustomerReferralOverviewArgs
  >(CUSTOMER_REFERRAL_OVERVIEW_QUERY, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  return {
    loading,
    error,
    refetch,
    totalReferrals: data?.customerReferralOverview?.totalReferrals ?? 0,
  };
};